import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'

const buttonText = {
  fontSize: 12,
  textAlign: 'center',
  fontWeight: '600',
}

const blueFinShadow = {
  shadowColor: 'PRIMARY_BLUE' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 3,
  },
  shadowOpacity: 0.3,
  shadowRadius: 8,
  elevation: 4,
}

const styles = {
  mainHeaderView: {
    flexDirection: 'row',
    paddingVertical: 15,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 25,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomWidth: 1,
    borderBottomColor: 'VERY_LIGHT_GREY',
    width: '100%',
    justifyContent: 'space-between',
  } as BoxProps,

  leftAligned: {
    justifyContent: 'space-between',
    width: '45%',
  } as BoxProps,

  rightAligned: {
    width: '45%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  } as BoxProps,

  borderedButton: {
    paddingVertical: 10,
    paddingHorizontal: 25,
    borderRadius: 4,
    borderColor: 'PRIMARY_BLUE' as ColorOptions,
    borderWidth: 1,
    justifyContent: 'center',
    alignSelf: 'center',
    ...blueFinShadow,
  } as BoxProps,

  backgroundButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 4,
    backgroundColor: 'PRIMARY_BLUE' as ColorOptions,
    justifyContent: 'center',
    alignSelf: 'center',
    marginLeft: 15,
    ...blueFinShadow,
  } as BoxProps,

  cancelText: {
    ...buttonText,
    color: 'PRIMARY_BLUE' as ColorOptions,
  } as TextProps,

  whiteText: {
    ...buttonText,
    color: 'WHITE',
  } as TextProps,

  headerText: {
    color: 'BLACK_75',
    fontWeight: '800',
    fontSize: 14,
  } as TextProps,

  subtitleText: {
    color: 'LIGHT_BLACK',
    fontWeight: '600',
    fontSize: 11,
  } as TextProps,

  rightSecondButton: {
    marginLeft: 15,
  },
}

export default styles
